import React, {useState, useEffect, useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import { useSound } from '../context/SoundContext';

import Button from "../components/Button";
import styles from "../styles/Learn.module.scss";
import MessageBubble from "../components/MessageBubble";

import {CabinetStep, emtyDay, LearnStep} from "../services/types";
import PatientCard from "../components/PatientCard";
import PCWindow from "../components/PCWindow";
const base = process.env.PUBLIC_URL || ``;

// function getCookie(name: any) {
//     const matches = document.cookie.match(
//         new RegExp(
//             "(?:^|; )" +
//             name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") +
//             "=([^;]*)"
//         )
//     );
//     return matches ? decodeURIComponent(matches[1]) : undefined;
// }


const steps: LearnStep[] = [
    {
        name: '',
        text: '<strong>+30 баллов рейтинга за начало работы в Северокрайске!\n\n🏆 Ваш рейтинг: 30⭐</strong>️\n\nТак легко баллы больше не достанутся, придется подумать, проверить свои знания и узнать много нового!\n\n📈<strong>Как повысить рейтинг?</strong>\n✅ За каждый верный ответ вы получаете баллы рейтинга! 🩺🧠\n✅ Изучение новой информации в приложении увеличивает шансы на верные решения!',
        positionTop: false,
        topFull: false,
        transform: 'translateX(-57%) translateY(-50%)',
        left: '50%',
        height: '100%',
        draggable: false,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:"1", value: false, redColor: false, answered: false}
        ]
    },
    {
        name: '',
        text: '💡 Навигация по интерактивной практике!',
        positionTop: true,
        topFull: true,
        transform: 'translateX(-57%) translateY(-50%)',
        left: '50%',
        height: '100%',
        draggable: false,
        buttons: [
            {text: "Сразу к практике!", type: "nextStep", gotoStep:"5", value: true, redColor: false, answered: false},
            {text: "Пройти обучение", type: "nextStep", gotoStep:"2", value: false, redColor: false, answered: false},
        ]
    },
    {
        name: '',
        text: '<strong>1/3</strong> На столе всегда лежат карточки пациентов с историей болезни.',
        positionTop: true,
        topFull: false,
        transform: 'translateX(-38.54%) translateY(-77.22%)',
        left: '50%',
        height: '226%',
        draggable: false,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:"3", value: false, redColor: false, answered: false},
        ]
    },
    {
        name: '',
        text: '<strong>2/3</strong> Анализы пациентов и таблица с динамикой изменения показателей крови — всегда в компьютере.',
        positionTop: true,
        topFull: false,
        transform: 'translateX(-58.64%) translateY(-66%)',
        left: '50%',
        height: '155%',
        draggable: false,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:"4", value: false, redColor: false, answered: false},
        ]
    },
    {
        name: '',
        text: '<strong>3/3</strong> Принимайте верные решения и повышайте свой личный рейтинг!',
        positionTop: true,
        topFull: false,
        transform: 'translateX(-57%) translateY(-50%)',
        left: '50%',
        height: '100%',
        draggable: false,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:"5", value: false, redColor: false, answered: false},
        ]
    },
    {
        name: '',
        text: 'Практика началась! Вас ждет пациент.',
        positionTop: false,
        topFull: false,
        transform: 'translateX(-50%) translateY(-50%)',
        left: '50%',
        height: '100%',
        draggable: false,
        buttons: [
            {text: "Далее", type: "nextStep", gotoStep:"6", value: false, redColor: false, answered: false},
        ]
    },
    {
        name: '💡 Подсказка:',
        text: 'Кликайте на <strong>"Карточки пациентов"</strong> 🗂️, чтобы <strong>узнать ФИО и важную информацию</strong> о вашем пациенте! 👨‍⚕️📋',
        positionTop: true,
        topFull: false,
        transform: 'translateX(0%) translateY(-50%)',
        left: '0%',
        height: '100%',
        draggable: true,
        buttons: [
            {text: "Далее", type: "gotoToGame", gotoStep:"7", value: true, redColor: false, answered: false},
        ]
    },
    {
        name: '',
        text: '',
        positionTop: true,
        topFull: false,
        transform: 'translateX(0%) translateY(-50%)',
        left: '0%',
        height: '100%',
        draggable: true,
        buttons: [
            {text: "Далее", type: "gotoToGame", gotoStep:"6", value: true, redColor: false, answered: false}
        ]
    },
    {
        name: '',
        text: '<strong>🎉 Бесценная награда! Получайте гематогенку за изучение образовательных материалов внутри игры!</strong></br></br>🍫 Соберите 6 и более гематогенок — и в финале игры получите 🎁 стикерпак ГЕМАТОЛОГА!',
        positionTop: false,
        topFull: false,
        transform: 'translateX(0%) translateY(-50%)',
        left: '0%',
        height: '100%',
        draggable: false,
        buttons: [
            {text: "Назад", type: "nextStep", gotoStep:'7', value: false, redColor: false, answered: false},
        ]
    },
    {
        name: '',
        text: '',
        positionTop: false,
        topFull: false,
        transform: 'translateX(0%) translateY(-50%)',
        left: '0%',
        height: '100%',
        draggable: false,
        buttons: [
        ]
    }

];

function setCookie(name: any, value: any, days = 7) {
    try { localStorage.setItem(String(name), String(value)); } catch {}
}

function getCookie(name: any): string | undefined {
    try {
        const v = localStorage.getItem(String(name));
        return v === null ? undefined : v;
    } catch { return undefined; }
}
// function setCookie(name: any, value: any, days = 7) {
//     const expires = new Date(Date.now() + days * 864e5).toUTCString();
//     document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
// }
export const LearnPage = () => {
    const cabinetBody = document.getElementById('root')
    const cabinetBodyBg = document.getElementById('cabinetBodyBg')
    const [currentStep, setCurrentStep] = useState(0);
    const navigate = useNavigate();
    const [dragStartX, setDragStartX] = useState<number | null>(null);
    const [dragDelta, setDragDelta] = useState(0);
    const isDragging = useRef(false);
    const [curentLeft, setCurrentLeft] = useState<any>(cabinetBody!!.offsetWidth / 2 - cabinetBody!!.offsetHeight / 2);
    const [curentMoveLeft, setCurrentMoveLeft] = useState<any>(cabinetBody!!.offsetWidth / 2 - cabinetBody!!.offsetHeight / 2);
    const [step, setStep] = useState<CabinetStep>(emtyDay);

    // @ts-ignore
    const { muted, toggleMuted } = useSound();
    const handleSound = () => {
        toggleMuted(); // тут меняем значение в контексте
    };

    const stepPoints = [{
        step: 'LearnPoints',
        points: 30
    }]
    const stepPointsCookie = getCookie('stepPoints');

    if (!stepPointsCookie){
        setCookie('stepPoints', JSON.stringify(stepPoints))
    }



    const handleClick = (type: string, value: boolean, step: string) => {
        if (type === "nextStep"){
            localStorage.setItem('rating', '30')
            console.log(step)
            // @ts-ignore
            setCurrentStep(step*1)
        }else if (type === "gotoToGame"){
            if (!value){
                // @ts-ignore
                setCurrentStep(step*1)

            }else{
                navigate('/cabinet')
            }
        }
    }


    const handleMouseDown = (e: React.MouseEvent) => {
        isDragging.current = true;
        setDragStartX(e.clientX);
    };
    const handleMouseMove = (e: React.MouseEvent) => {
        if (!isDragging.current || dragStartX === null) return;
        if (document.getElementById('cabinetBody') !== null) {
            if (curentLeft + (e.clientX - dragStartX) > 0) {
                setCurrentMoveLeft(0)
            } else if (curentLeft + (e.clientX - dragStartX) < cabinetBody!!.offsetWidth - cabinetBodyBg!!.offsetWidth) {
            } else {
                setCurrentMoveLeft(curentLeft + (e.clientX - dragStartX))
            }
        }
    };
    const handleMouseUp = () => {
        setCurrentLeft(curentMoveLeft)
        isDragging.current = false;
    };

    const handleTouchStart = (e: React.TouchEvent) => {
        isDragging.current = true;
        setDragStartX(e.touches[0].clientX);
    };
    const handleTouchMove = (e: React.TouchEvent) => {
        if (!isDragging.current || dragStartX === null || !steps[currentStep]!.draggable) return;
        if (document.getElementById('cabinetBody') !== null) {
            if (curentLeft + (e.touches[0].clientX - dragStartX) > 0) {
                setCurrentMoveLeft(0)
            } else if (curentLeft + (e.touches[0].clientX - dragStartX) < cabinetBody!!.offsetWidth - cabinetBodyBg!!.offsetWidth) {
            } else {
                setCurrentMoveLeft(curentLeft + (e.touches[0].clientX - dragStartX))
            }
        }

    };
    const handleTouchEnd = () => {
        setCurrentLeft(curentMoveLeft)
        isDragging.current = false;
    };

    return (
        <div id="cabinetBody" className={styles.Container}>
            <>
                <div id="cabinetBodyBg" className={styles.LearnBackground}
                     style={{
                         transform: steps[currentStep].transform,
                         height: steps[currentStep].height,
                         top: step!.top,
                         ...(currentStep > 5 && {left: curentMoveLeft, transition: 'none'}),
                         ...(currentStep <= 5 && {left: steps[currentStep].left, transition: step!.transition}),
                         ...(currentStep == 8 && {filter: 'blur(5px)'})
                     }}
                     // style={{transform: steps[currentStep].transform, height: steps[currentStep].height, left: steps[currentStep].left}}
                     onMouseDown={handleMouseDown}
                     onMouseMove={handleMouseMove}
                     onMouseUp={handleMouseUp}
                     onMouseLeave={handleMouseUp}
                     onTouchStart={handleTouchStart}
                     onTouchMove={handleTouchMove}
                     onTouchEnd={handleTouchEnd}
                >
                    <img src={`${base}/images/cabinet.jpg`} className={styles.stepBg} alt="Step" />

                    {currentStep > 6 &&
                        <>
                        <div className={styles.PCBtn} onClick={() => handleClick("nextStep", false, '9')}></div>
                        <div className={styles.gemoBtn} onClick={() => handleClick("nextStep", false, '8')}></div>
                        <div className={styles.PatientCardBtn} onClick={() => handleClick("gotoToGame", true, "10")}></div>
                        </>
                    }
                </div>
                {currentStep === 8 &&
                    <img src={`${base}/images/gemo.png`} className={styles.gemoBg} alt="Step" />
                }
                {/*<img src=`${base}/images/info.svg` className={`${styles.instructionIcon}`} alt="instructionIcon" />*/}
                {!muted ?
                    <img src={`${base}/images/sound.svg`} className={styles.soundMutedIcon} alt="soundMutedIcon" onClick={handleSound}/>
                    :
                    <img src={`${base}/images/sound_off.svg`} className={styles.soundMutedIcon} alt="soundMutedIcon" onClick={handleSound}/>
                }
                {(steps[currentStep].name !== "" || steps[currentStep].text !== "") &&
                    <MessageBubble label={steps[currentStep].name} positionTop={steps[currentStep].positionTop} text={steps[currentStep].text} textHeight="auto" textIsMaxSize={false} bitTitle={false} topFull={steps[currentStep].topFull}/>
                }
                <div className={styles.stepButtons}>
                {steps[currentStep].buttons.map((button, index) => (
                    <Button
                        label={button.text}
                        redColor={button.redColor}
                        answered={button.answered}
                        onClick={()=>handleClick(button.type, button.value, button.gotoStep)}
                    />
                ))}
                </div>
                {currentStep === 9 && (
                    <PCWindow
                        windowType={0}
                        cards={
                            [
                                [""],
                                [""],
                                [""],
                                [""],
                                [""]
                            ]
                        }
                        cardsHeight={
                            [
                                [394],
                                [357],
                                [342],
                                [472],
                                [747]
                            ]
                        }
                        onClick={() => handleClick("nextStep", true, '7')}
                        onClickEnter={() => handleClick("nextStep", true, '7')}
                    />
                )}
            </>
        </div>
    );
};
